import { useState, useEffect } from 'react';

const ExtraContent = () => {
  const [avatarUrl, setAvatarUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const imageUrl = 'https://ilyashirko.dev/static/images/avatar.png';
  const fallbackUrl = 'https://via.placeholder.com/300x300?text=Avatar+Not+Found';

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      setAvatarUrl(imageUrl);
      setIsLoading(false);
    };

    img.onerror = () => {
      setError('Failed to load image');
      setAvatarUrl(fallbackUrl);
      setIsLoading(false);
    };
  }, [imageUrl]);

  return (
    <div id="extraContent" className="extraContent">
      {isLoading ? (
        <div>Loading avatar...</div>
      ) : (
        <img 
          className="avatar" 
          // src={avatarUrl}
          src={`${process.env.PUBLIC_URL}/images/avatar.png`}
          alt="Avatar" 
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fallbackUrl;
          }}
        />
      )}

    </div>
  );
};

export default ExtraContent;